import React, { useState, useRef, useEffect } from 'react';
import './FinishSetup.scss';
import { Button, Spinner } from 'react-bootstrap';
import { ArrowBack } from '@mui/icons-material';
import { post } from '../../Utilities';
import BackdropLoader from '../Common/BackdropLoader/BackdropLoader';

const ClassSelection = (props) => {
  const {
    goToUserSelection,
    goToMain,
    targets = [],
    currentBranding,
    clientId,
    clientUserId,
    selectedRole,
    selectedBatch,
  } = props;
  const [selectedTarget, setSelectedTarget] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const contentRef = useRef(null);

  const handleScroll = () => {
    if (!contentRef.current) return;
    setScrolled(contentRef.current.scrollTop > 0);
  };

  const submit = () => {
    setIsLoading('Updating your target. Please wait for a while');
    const payload = {
      client_user_id: clientUserId,
      batch_add: Array.isArray(selectedTarget)
        ? JSON.stringify(selectedTarget)
        : JSON.stringify([selectedTarget]),
      client_id: clientId,
      batch_remove: currentBranding.branding.default_batch_id,
      role_id: selectedRole,
    };

    post(payload, '/changeBatchOfUserMulyankan').then((res) => {
      if (res && res.success) {
        setTimeout(() => {
          goToMain();
          setIsLoading(false);
        }, 2000);
      }
    });
  };

  useEffect(() => {
    const selectedId = targets?.find((ele) => ele.title === selectedBatch)?.id;
    console.log(selectedBatch, targets, 'aaa');
    if (selectedId) {
      setSelectedTarget(targets?.find((ele) => ele.title === selectedBatch)?.id);
    }
  }, [targets]);

  return (
    <div className='ClassSelection__container'>
      <BackdropLoader isLoading={isLoading} />
      <div
        className='ClassSelection__header'
        style={{ background: scrolled ? 'var(--lightest-blue)' : 'var(--superlight-blue)' }}
      >
        <ArrowBack onClick={goToUserSelection} className='mb-3' />
        <h1 className='ClassSelection__title'>Select your target</h1>
        <p className='ClassSelection__subtitle mb-0'>You can change this later in settings</p>
      </div>

      <div className='ClassSelection__content' ref={contentRef} onScroll={handleScroll}>
        <div className='ClassSelection__list'>
          {targets.length === 0 ? (
            <div className='w-100 text-center mx-auto my-4'>
              <Spinner animation='border' role='progress' />
            </div>
          ) : (
            targets.map((target) => (
              <div
                key={target.id}
                className={`ClassSelection__card ${
                  selectedTarget === target.id ? 'ClassSelection__card--selected' : ''
                }`}
                onClick={() => setSelectedTarget(target.id)}
              >
                <div className='ClassSelection__avatar'>{target.initial}</div>
                <div className='ClassSelection__info'>
                  <h3
                    className='ClassSelection__cardTitle'
                    style={selectedTarget === target.id ? { color: 'var(--superlight-blue)' } : {}}
                  >
                    {target.title}
                  </h3>
                  <p
                    className='ClassSelection__cardSubtitle'
                    style={selectedTarget === target.id ? { color: 'var(--superlight-blue)' } : {}}
                  >
                    {target.subtitle}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <div className='ClassSelection__footer'>
        <Button
          disabled={!selectedTarget}
          variant='customPrimary'
          onClick={submit}
          className='ClassSelection__nextButton py-2'
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ClassSelection;
